// src/components/ui/Button.js
import React from "react";

const VARIANT_CLASS = {
  default: "",
  primary: "btn--primary",
  ghost: "btn--ghost",
  danger: "btn--danger",
};

function Button({
  variant = "default",
  size,
  block = false,
  className = "",
  type = "button",
  children,
  ...rest
}) {
  const classes = [
    "btn",
    VARIANT_CLASS[variant] || "",
    size === "sm" ? "btn--sm" : "",
    block ? "btn--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}

export default Button;
